import request from '../utils/Request';
import { Methods } from '../config';
import { createEvent } from '@testing-library/react';

const baseURL = 'app';

const appService = {
  getMenuData: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/getMenuData`,
    });
  },

  getUserPermissions: (roleId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/getUserPermissions/${encodeURIComponent(roleId)}`,
    });
  },

  getDocPermissions: (roleId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/getDocPermissions/${encodeURIComponent(roleId)}`,
    });
  },

  getRole: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/getRole`,
    });
  },

  addRole: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/addRole`,
      data,
    });
  },

  updateRole: (data, roleId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/role/${encodeURIComponent(roleId)}`,
      data,
    });
  },

  getRoleInformation: (roleId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/getRoleInformation?roleId=${roleId}`,
    });
  },

  getUserSubMenuPermissions: (roleId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/getUserSubMenuPermissions?roleId=${roleId}`,
    });
  },

  getBiPermissions: (roleId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/biPermissions/${encodeURIComponent(roleId)}`,
    });
  },

  getDashboardPermissions: (roleId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/dashboardPermissions/${encodeURIComponent(roleId)}`,
    });
  },

  getRoleListPermissions: (roleId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/roleListPermissions/${encodeURIComponent(roleId)}`,
    });
  },

  getAllSubMenus: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/getAllSubMenus`,
    });
  },

  updateSubMenuPermission: (roleId, selectedSubMenu, permission, canEdit, canCopy, canDelete) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/updateSubMenuPermission?roleId=${roleId}&subMenuId=${selectedSubMenu}&hasPermission=${permission}`,
      data: { canEdit, canCopy, canDelete },
    });
  },

  updateSubmenuActive: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/updateSubmenuActive`,
      data,
    });
  },

  updateBiRolePermission: (roleId, selectedBiReport, permission) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/updateBiPermission?roleId=${roleId}&biReportId=${selectedBiReport}&hasPermission=${permission}`,
    });
  },

  updateDashboardRolePermission: (roleId, selectedDashboardReport, permission) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/updateDashboardPermission?roleId=${roleId}&dashboardId=${selectedDashboardReport}&hasPermission=${permission}`,
    });
  },

  updateRoleListPermission: (roleId, code, permission, value) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/updateRoleListPermission?roleId=${roleId}&roleListCode=${code}&hasPermission=${permission}&value=${value}`,
    });
  },

  updateDocPermission: (roleId, selectedDocType, permission, canEdit, canCopy, canDelete, canEmailSend) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/updateDocPermission?roleId=${roleId}&docTypeId=${selectedDocType}&hasPermission=${permission}`,
      data: { canEdit, canCopy, canDelete, canEmailSend },
    });
  },

  getJoinedData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/getJoinedData`,
      data,
    });
  },

  addItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/addItem`,
      data,
    });
  },

  setItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/setItem`,
      data,
    });
  },

  updateTable: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/updateTable`,
      data,
    });
  },

  deleteItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/deleteItems`,
      data,
    });
  },

  getStatus: (menuId) => {
    //@TODO backend
    return request({
      method: Methods.GET,
      resource: `${baseURL}/status/${encodeURIComponent(menuId)}`,
    });
  },

  getPriority: (menuId) => {
    //@TODO backend
    return request({
      method: Methods.GET,
      resource: `${baseURL}/priority/${encodeURIComponent(menuId)}`,
    });
  },

  getParams: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/getParams`,
    });
  },

  getConfig: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/config`,
    });
  },

  updateUserView: (data, userId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/userview/${encodeURIComponent(userId)}`,
      data,
    });
  },

  getMessages: (addressedTo) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/messages/${encodeURIComponent(addressedTo)}`,
    });
  },

  getMessagesCount: (addressedTo) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/messagesCount/${encodeURIComponent(addressedTo)}`,
    });
  },

  updateReadAt: (id) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  updateAllMsgReadAt: (addressedTo) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/allMessage/${encodeURIComponent(addressedTo)}`,
    });
  },

  getStatusBySubMenuId: (subMenuId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/statusItems/${encodeURIComponent(subMenuId)}`,
    });
  },

  getTypeBySubMenuId: (subMenuId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/typeItems/${encodeURIComponent(subMenuId)}`,
    });
  },

  getResponsiblePersons: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/responsiblePersons`,
    });
  },

  getEmployees: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/employees`,
    });
  },

  getVehicles: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/vehicles`,
    });
  },

  getEventLog: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/eventLogData`,
      data,
    });
  },

  createSystemLog: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/systemLog`,
      data,
    });
  },

  createEventLog: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/eventLog`,
      data,
    });
  },
  updateEventLog: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/eventLog`,
      data,
    });
  },

  updateColorLink: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/color/createColor`,
      data,
    });
  },

  deleteColorLink: (subMenuUrl, lineId, type) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(subMenuUrl)}/${encodeURIComponent(lineId)}/${encodeURIComponent(type)}`,
    });
  },
};

export default appService;
